<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', usuario)">
      <v-card v-if="usuario" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Usuário </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="usuario.nome"
                    label="Nome"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="usuario.perfil.id"
                    :items="itens.perfil"
                    :rules="[obrigatorio]"
                    label="Perfil"
                    no-data-text="Nenhum perfil encontrado"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="usuario.login"
                    :rules="[obrigatorio]"
                    :disabled="operacao === 'editar'"
                    label="Login"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="usuario.senha"
                    :rules="operacao === 'adicionar' ? [obrigatorio] : []"
                    label="Senha"
                    type="password"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="usuario.email"
                    :rules="[obrigatorio, emailInvalido]"
                    label="E-mail"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="usuario.empresa.id"
                    :items="itens.empresa"
                    :rules="[obrigatorio]"
                    label="Empresa"
                    no-data-text="Nenhuma empresa encontrada"
                  />
                </v-col>
              </v-row>
              <v-switch v-if="operacao === 'editar'" v-model="usuario.ativo" label="Ativo" dense />
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(usuario)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Usuario from '../../models/usuario'
import UsuarioService from '../../services/usuario/usuario'
import { obrigatorio, emailInvalido } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'usuarioParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    usuario: new Usuario(),
    showMessageError: false,
    obrigatorio: obrigatorio,
    emailInvalido: emailInvalido,
    salvando: false,
    validForm: false,
    dataError: ''
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    usuarioParam() {
      return this.usuarioParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.usuario = new Usuario()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.usuario = this.usuarioParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false
      try {
        const data = {
          ...item
        }

        const usuarioSalvo =
          this.operacao === 'adicionar'
            ? await UsuarioService.create(data)
            : await UsuarioService.update(data.id, data)

        this.$emit('confirmado', usuarioSalvo)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
